// HACK: It is all hack here
// This method is only for testing for AIA POC
// It will delete all components from test_uat
// It will fetch all components of AIA and duplicate them to test_uat
// We do this to not screw up actual aia_uat when fiddling with things in Studio
import gql from "@/api/gql"
import api from "@/api/api"

const query = {
	aiaUatToken: gql`
		query aia_admin {
			token_2(tenantId: "aia_uat", clientId: "covergo_crm", username: "admin@covergo.com", password: "CovergoCloud1") {
				accessToken
			}
		}
	`,

	createComponent: gql`
		mutation createComponent($input: createComponentInput!) {
			createComponent(input: $input) {
				status
				createdStatus {
					id
				}
				errors
			}
		}
	`,

	components: gql`
		query components($where: componentWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
			components(where: $where, limit: $limit, skip: $skip, sort: $sort) {
				list {
					id
					name
					vueTemplate
					status
				}
			}
		}
	`
}

const initAia = async () => {
	// Get aia token
	let aia_uatToken = await api({ query: query.aiaUatToken, variables: {}, token: null })

	// Get all components from aia
	const components = await api({ query: query.components, variables: {}, token: aia_uatToken?.data?.token_2?.accessToken })
	aia_uatToken = null // destroy token just to be sure

	// Create components in test_uat
	const res = await Promise.all(
		components?.data?.components?.list?.map(comp =>
			api({
				query: query.createComponent,
				variables: {
					input: {
						version: { version: "2.6.11", framework: "vue" },
						name: comp.name,
						vueTemplate: comp.vueTemplate,
						componentJsonString: "{}"
					}
				}
			})
		)
	)

	console.log("created components", { res })
}

export { initAia }
